import { render, staticRenderFns } from "./BaseIconButtonComment.vue?vue&type=template&id=0c5fc757&scoped=true&"
import script from "./BaseIconButtonComment.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5fc757",
  null
  
)

export default component.exports